import Back from '../Back';
import Content from '../Content';
import styles from '../common/DevTools.module.scss';
import shouldBeSelected from '../helpers/shouldBeSelected';
import useDevTools from '../hooks/useDevTools';
import cn from 'classnames';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

const Palette = () => {
  const { setMenu, menu } = useDevTools();

  const colors = useSelector((state) => state.measures.colors);

  const data = useMemo(() => {
    return colors.map((color) => ({
      name: color.name,
      color: color.color,
      id: color.id,
    }));
  }, [colors]);

  return (
    <>
      <Back title={'Palette'} />

      <Content>
        <ul className={styles.list}>
          {data.map((item) => {
            return (
              <li
                key={item.id}
                onClick={() => {
                  setMenu(1, 'palette-details', {
                    id: item.id,
                    menuIndex: 1,
                    name: item.id,
                  });
                }}
                className={cn(shouldBeSelected(item.id, menu, 0) && styles.selected)}
              >
                <div className={styles.name}>{item.name}</div>
                <div>
                  <div className={styles.color} style={{ backgroundColor: item.color }} />
                </div>
              </li>
            );
          })}
        </ul>
      </Content>
    </>
  );
};

export default Palette;
